// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cf-4";
export var closeButton = "_cf-6";
export var dismissButton = "_cf-3";
export var editImageWithAiContainer = "_cf-8";
export var imageUploadWrapper = "_cf-7";
export var misspelledWord = "_cf-5";
export var spellCheckContainer = "_cf-2";
export var spin = "_cf-1";
export var spinning = "_cf-0";